export default "__VITE_ASSET__B1Me6vhH__"